import type { ProgramSeason, ProgramDetails } from '../../interface/Program';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

const getProgramSeasons = async (
  id: ProgramDetails['id'],
  isRestricted: boolean
) => {
  try {
    const { data } = await api.get<{ data: ProgramSeason[] }>(
      apiConfig.routes.entertainment.program.seasons(id, isRestricted)
    );

    return data.data;
  } catch {
    const { data } = await api.get<{ data: ProgramSeason[] }>(
      apiConfig.routes.entertainment.program.publicSeasons(id)
    );

    return data.data;
  }
};

export const useGetProgramSeasons = (
  id: ProgramDetails['id'],
  isRestricted = false
) =>
  useQuery({
    queryKey: ['program', id, 'seasons', `restricted=${isRestricted}`],
    queryFn: () => getProgramSeasons(id, isRestricted),
    enabled: !!id,
  });
